<template>
  <a-modal
    :key="!isActive"
    v-model="isActive"
    :maskClosable="isEmpty"
    :width="900"
    :zIndex="55000"
    :height="300"
    :title="$t('newDelivery')"
    style="top: 20px;"
    @cancel="clearUp">

    <a-steps v-model="step" type="navigation" @change="()=> {}">
      <a-step title="Pedidos" :description="`${orders.length} item${orders.length > 1 ? 's' : '' }`" />
      <a-step title="Entrega" :description="deliveryType" />
      <a-step title="Pagamento" :description="paymentType" />
    </a-steps>
    
    <vs-divider border-style="dashed"/>

    <div v-show="step === 0">
      <new-order :forDelivery="true" class="contain"/>
    </div>
    <div v-show="step === 1">
      <delivery-address @changeType="(v) => deliveryType = v" @valid="v => addressIsValid = v"/>
    </div>
    <div v-show="step === 2">
      <delivery-payment-summary @changePayment="(v) => paymentType = v" @valid="v => paymentIsValid = v"/>
    </div>

    <template v-slot:footer>
      <div class="vx-row justify-between items-center" style="padding: 4px">
        <div class="vx-row ml-1">
          <h5 style="margin: 0" class="ml-4"><b>{{orders.length}} item{{orders.length > 1 ? 's' : '' }}</b></h5>
          <h5 style="margin: 0" class="ml-4">-</h5>
          <h4 style="margin: 0" class="ml-4">{{ ordersValue | currency }}</h4>
        </div>
        <vs-button v-if="isValid || step == 2" @click="proceed" :disabled="!isValid"
           color="success" class="mr-3" icon="check"> Criar Pedido</vs-button>
        <vs-button v-else @click="step++"
          class="mr-3" icon-after icon="keyboard_arrow_right"> Prosseguir </vs-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
  import NewOrder from '../bill/NewOrder';
  import DeliveryAddress from './DeliveryAddress';
  import DeliveryPaymentSummary from './DeliveryPaymentSummary';
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
  export default {
    components: {
      NewOrder,
      DeliveryAddress,
      DeliveryPaymentSummary
    },
    props: {
      value: Boolean
    },
    data() {
      return {
        step: 0,
        paymentType: '',
        deliveryType: '',
        addressIsValid: false,
        paymentIsValid: false,
      }
    },
    watch : {
      orders : {
        handler(val) {
          if(!val.length)
            this.step = 0
        },
        deep : true
      }
    },
    computed: {
      isActive: {
        get () {
          return this.value; 
        },
        set (value) {
          this.$emit('input', value);
        }
      },
      isEmpty () {
        return !this.orders.length && !this.addressIsValid && !this.paymentIsValid;
      },
      isValid () {
        return this.orders.length && this.addressIsValid && this.paymentIsValid;
      },
      ...mapState('delivery', ['orders']),
      ...mapGetters('delivery', ['ordersValue'])
    },
    methods: {
      async proceed () {
        try {
          this.$vs.loading()
          await this.sendDeliveryOrder();
          this.$message.success('Pedido realizado com sucesso!', 5);
          this.isActive = false;
          this.paymentIsValid = false
          this.addressIsValid = false
        } catch (err) {
          this.$error({
              title: 'Erro ao carregar pedidos!',
              content: err.message
          })
        } finally {
          this.$vs.loading.close();
        }
      },
      ...mapActions('delivery', ['sendDeliveryOrder']),
      ...mapMutations('delivery', ['clearUp'])
    },
  }
</script>

<style lang="scss" scoped>
.contain {
  padding-right: 8px;
  padding-left: 8px;
  // height: calc(90vh - 300px);
  overflow-x: hidden;
  overflow-y: auto;
}
</style>